<!--<template>-->

<!--    <div id="fb-post">-->
<!--        <div class="headline ma-3 text-color bold">-->
<!--            Buff Mắt SV V1-->
<!--        </div>-->
<!--        <v-alert type="info">-->
<!--            Comming soon.-->
<!--        </v-alert>-->
<!--        <div class="container-tabs" style="display: none">-->
<!--            <v-tabs-->
<!--                    :background-color="COLOR.BG_MAIN_COLOR"-->
<!--            >-->
<!--                <v-tab href="#create-process" active-class="text-color">Tạo tiến trình</v-tab>-->
<!--                <v-tab href="#activity-log"  active-class="text-color">Nhật ký Order</v-tab>-->
<!--                <v-tab-item value="create-process">-->
<!--                    <FbFollowCreateProcess />-->
<!--                </v-tab-item>-->
<!--                <v-tab-item value="activity-log">-->
<!--                    <FbFollowActivityLog />-->
<!--                </v-tab-item>-->
<!--            </v-tabs>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script>-->
<!--    import FbFollowCreateProcess from "~/components/fb-follow/FbFollowCreateProcess";-->
<!--    import FbFollowActivityLog from "~/components/fb-follow/FbFollowActivityLog";-->
<!--    import { COLOR, SEEDING_TYPE } from "~/config/constant";-->
<!--    export default {-->
<!--        components: {-->
<!--            FbFollowCreateProcess,-->
<!--            FbFollowActivityLog-->
<!--        },-->
<!--        data() {-->
<!--            return {-->
<!--                COLOR: COLOR-->
<!--            }-->
<!--        },-->

<!--    };-->
<!--</script>-->
<!--<style lang="scss">-->
<!--    @import "../../scss/main";-->
<!--    #fb-post {-->
<!--        .v-tabs-slider-wrapper {-->
<!--            color: $mainColor !important;-->
<!--        }-->
<!--        .text-color{-->
<!--            color: $mainColor;-->
<!--            font-weight: bold;-->
<!--        }-->
<!--    }-->
<!--</style>-->

<template>
    <div id="fb-post">
        <div class="headline ma-3 text-color bold">
            BUFF MẮT CHO LIVE STREAM
        </div>
        <div class="container-tabs" v-if="maintain">
            <h1 class="maintain_notice">Job này đang bảo trì</h1>
        </div>
        <div class="container-tabs" v-else>
            <v-tabs :background-color="COLOR.BG_MAIN_COLOR">
                <v-tab href="#create-process" active-class="text-color">Tạo tiến trình</v-tab>
                <v-tab href="#activity-log"  active-class="text-color">Nhật ký Order</v-tab>
                <v-tab-item value="create-process">
                    <FbStreamCreateProcess />
                </v-tab-item>
                <v-tab-item value="activity-log">
                    <FbStreamActivityLog />
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
  import FbStreamCreateProcess from "~/components/fb-stream/FbStreamCreateProcess";
  import FbStreamActivityLog from "~/components/fb-stream/FbStreamActivityLog";
  import { COLOR, SEEDING_TYPE } from "~/config/constant";
  import { SEEDING_TYPE_MAINTAIN } from "~/store/actions.type";

  export default {
    components: {
      FbStreamCreateProcess,
      FbStreamActivityLog
    },
    data() {
      return {
        COLOR: COLOR,
        maintain: false
      }
    },
      methods: {
          async getDataFromApi () {
              let dataInfo = await this.$store.dispatch(SEEDING_TYPE_MAINTAIN);
              if (dataInfo.includes(SEEDING_TYPE.ID_FACEBOOK_BUFF_EYE_STREAM)) {
                  this.maintain = true;
              }
          },
      },
      mounted() {
          this.getDataFromApi();
      },
  };
</script>
<style lang="scss">
    @import "../../scss/main";
    #fb-post {
        .v-tabs-slider-wrapper {
            color: $mainColor !important;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
    }
</style>
